import system from "./system";

const components = {
  button: {
    fontFamily: system.fonts.body,
    fontSize: "18px",
    border: "2px solid white",
    color: "white",
  },
  divider: {
    backgroundColor: "rgba(255, 255, 255, 0.3)",
  },
  pageHeader: {
    fontFamily: system.fonts.heading,
    color: system.colors.text.primary,
    fontSize: "44px",
    letterSpacing: "0.1em",
    fontWeight: "400",
  },
  sectionHeader: {
    fontFamily: system.fonts.heading,
    fontSize: "36px",
    lineHeight: "1.8",
    fontWeight: "bold",
    color: system.colors.text.primary,
  },
  loading: {
    color: system.colors.text.primary,
  },
  footer: {
    color: system.colors.text.primary,
    fontFamily: system.fonts.body,
    fontSize: "16px",
    fontWeight: "bold",
  },
  howToUseSlider: {
    paper: {
      boxShadow: "inset 0px 0px 10px rgba(248, 22, 22, 0.5)",
      borderRadius: 2,
      backgroundColor: system.colors.background.card,
    },
    overlay: {
      borderRadius: 1,
      backgroundColor: "rgba(255, 255, 255, 0.05)",
    },
    bullet: {
      active: "#fdfdfd",
      inactive: "#555555",
    },
    text: {
      point: {
        fontFamily: "Crimson Pro",
        fontSize: "16px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      title: {
        fontFamily: system.fonts.body,
        fontSize: "19px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      description: {
        fontFamily: system.fonts.body,
        fontSize: "15px",
        color: system.colors.text.primary,
      },
    },
  },
  newsItem: {
    text: {
      title: {
        fontFamily: system.fonts.body,
        color: system.colors.text.primary,
        fontSize: "14px",
      },
      date: {
        fontFamily: system.fonts.body,
        color: system.colors.text.secondary,
        fontSize: "12px",
      },
    },
  },
  myPageCard: {
    paper: {
      backgroundColor: system.colors.background.card,
      border: "0.5px solid rgba(255, 255, 255, 0.28)",
      boxShadow:
        "0 0 14px rgba(255, 255, 255, 0.42), 0 0 2px rgba(255, 255, 255, 0.58)",
    },
    media: {
      aspectRatio: "4 / 3",
      maxHeight: "none",
      minHeight: 0,
      objectFit: "contain",
      backgroundColor: "rgba(0, 0, 0, 0.45)",
    },
    text: {
      name: {
        fontFamily: system.fonts.heading,
        fontSize: "18px",
        fontWeight: 700,
        color: system.colors.text.primary,
      },
      remainingDays: {
        fontFamily: system.fonts.body,
        fontSize: "12px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      remainingDaysStrong: {
        color: "#D72828",
      },
      description: {
        fontFamily: system.fonts.body,
        fontSize: "15px",
        color: system.colors.text.primary,
      },
    },
  },
  questCard: {
    paper: {
      backgroundColor: system.colors.background.card,
      boxShadow: "0px 0px 4px rgba(200, 200, 200, 0.5)",
    },
    text: {
      name: {
        fontFamily: system.fonts.heading,
        fontSize: "16px",
        color: system.colors.text.primary,
        fontWeight: 700,
      },
      description: {
        fontFamily: system.fonts.body,
        fontSize: "12px",
        color: system.colors.text.primary,
      },
    },
    lockIcon: {
      color: "white",
    },
    chip: {
      cleared: {
        backgroundColor: "white",
        fontFamily: system.fonts.heading,
        color: "#333333", // 文字の色を指定
        fontWeight: 700,
      },
      uncleared: {
        backgroundColor: "rgba(80, 80, 80, 0.5)", // 黒い透明レイヤー
        fontFamily: system.fonts.heading,
        color: system.colors.text.primary,
        fontWeight: 700,
      },
    },
  },
  ticketBox: {
    text: {
      name: {
        fontFamily: system.fonts.body,
        fontSize: "22px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      description: {
        fontFamily: system.fonts.body,
        fontSize: "14px",
        color: system.colors.text.primary,
      },
      price: {
        fontFamily: system.fonts.body,
        fontSize: "22px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
      notice: {
        fontFamily: system.fonts.body,
        fontSize: "13px",
        fontWeight: "bold",
        color: system.colors.text.primary,
      },
    },
  },
  questRewardBox: {
    paper: {
      backgroundColor: "rgba(255, 255, 255, 0.2)", // 白い透明レイヤー
      borderRadius: "4px",
    },
    lockIcon: {
      color: "white",
    },
  },
  storySection: {
    name: {
      fontFamily: system.fonts.body,
      fontSize: "14px",
      fontWeight: "bold",
      color: system.colors.text.primary,
    },
    story: {
      fontFamily: system.fonts.body,
      fontSize: "18px",
      color: system.colors.text.primary,
      lineHeight: "1.8",
    },
  },

  dialog: {
    title: {
      fontFamily: system.fonts.heading,
      fontSize: "16px",
      color: system.colors.text.primary,
    },
    description: {
      fontFamily: system.fonts.body,
      fontSize: "14px",
      color: system.colors.text.primary,
    },
    width: "80%",
    backgroundColor: system.colors.background.dialog,
    button: {
      color: system.colors.text.primary,
    },
  },
};

export default components;
